/**
 * Chiffre clé : une valeur, son libellé, une indication. Touchable quand il
 * mène à la liste qui l'explique. Toujours en grille de deux au téléphone.
 */
import type { ReactNode } from 'react';
import { ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { t } from '../../core/i18n.js';

export function StatTile(props: {
  label: string;
  /** `null` : le chiffre n'existe pas encore (« Pas encore disponible »), jamais un tiret ni un zéro. */
  value: ReactNode | null;
  hint?: ReactNode;
  icon?: ReactNode;
  to?: string;
  tone?: 'default' | 'success' | 'warning' | 'danger';
}): ReactNode {
  const classes = ['ui-stat', props.tone && props.tone !== 'default' && `ui-stat--${props.tone}`].filter(Boolean).join(' ');
  const content = (
    <>
      {/* Sans icône ni lien, pas de bandeau vide au-dessus du chiffre. */}
      {props.icon || props.to ? (
        <span className="ui-stat__top">
          {props.icon ? <span className="ui-stat__icon" aria-hidden="true">{props.icon}</span> : null}
          {props.to ? <ChevronRight className="ui-stat__chevron" size={18} aria-hidden="true" /> : null}
        </span>
      ) : null}
      {props.value === null ? (
        <strong className="ui-stat__value ui-stat__value--empty">{t('commun.pasEncoreDisponible')}</strong>
      ) : (
        <strong className="ui-stat__value">{props.value}</strong>
      )}
      <span className="ui-stat__label">{props.label}</span>
      {props.hint ? <span className="ui-stat__hint">{props.hint}</span> : null}
    </>
  );
  return props.to ? (
    <Link className={classes} to={props.to}>
      {content}
    </Link>
  ) : (
    <div className={classes}>{content}</div>
  );
}

export function StatGrid(props: { label: string; children: ReactNode }): ReactNode {
  return (
    <div className="ui-stat-grid" role="group" aria-label={props.label}>
      {props.children}
    </div>
  );
}
